import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'crm-frm-animated-logo',
  templateUrl: './frm-animated-logo.component.html',
  styleUrls: ['./frm-animated-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'frm-animated-logo',
    role: 'img',
    'aria-label': 'ФРМ',
    '[class.frm-animated-logo--on-light]': 'surface === "light"'
  }
})
export class FrmAnimatedLogoComponent {
  @Input() public size = 44;

  /** `dark` — сайдбар CRM; `light` — тёмный круг на светлом фоне (шапка ЛК). */
  @Input() public surface: 'dark' | 'light' = 'dark';
}
